import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth/auth.service';
import { TokenService } from '../services/auth/token.service';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const tokenService = inject(TokenService);
  const router = inject(Router);

  try {
    // Verificar si el usuario está autenticado y tiene tokens válidos
    const isAuthenticated = authService.isAuthenticated();
    const hasValidAccessToken = tokenService.hasValidAccessToken();
    const hasValidRefreshToken = tokenService.hasValidRefreshToken();

    // Si está autenticado y tiene access token válido, permitir acceso
    if (isAuthenticated && hasValidAccessToken) {
      return true;
    }

    // Si tiene refresh token válido pero no access token, el interceptor se encargará
    if (isAuthenticated && hasValidRefreshToken) {
      return true;
    }

    // Si no tiene tokens válidos, cerrar sesión y redirigir al login
    if (isAuthenticated) {
      authService.logout();
    }

    // Redirect to login if not authenticated
    router.navigate(['/login'], {
      queryParams: { returnUrl: state.url },
    });
    return false;
  } catch {
    // En caso de cualquier error, siempre redirigir al login
    router.navigate(['/login']);
    return false;
  }
};
